import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseFavouriteFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4276 3.03959C13.2278 2.41997 12.6511 2 12 2C11.349 2 10.7722 2.41997 10.5724 3.03959L8.89824 8.23077L3.44378 8.21885C2.79273 8.21743 2.2151 8.63614 2.01392 9.25532C1.81273 9.87451 2.03394 10.5528 2.56148 10.9343L6.98123 14.1307L5.28438 19.3145C5.08184 19.9333 5.30156 20.612 5.82827 20.9947C6.35497 21.3774 7.0684 21.3766 7.59427 20.9927L12 17.7771L16.4058 20.9927C16.9316 21.3766 17.645 21.3774 18.1718 20.9947C18.6985 20.612 18.9182 19.9333 18.7156 19.3145L17.0188 14.1307L21.4385 10.9343C21.9661 10.5528 22.1873 9.87451 21.9861 9.25532C21.7849 8.63614 21.2073 8.21743 20.5562 8.21885L15.1018 8.23077L13.4276 3.03959Z"
        fill={color}
      />
    </svg>
  );
};
